import api from '@/api/app'
const notes = {
  information: {
    viewInfo: {
      obj: {
        basics: [
          // {
          //     label: "类型：",
          //     model: "type_name",
          //     type: "text",
          //     status: 0,
          // },
          // {
          //   label: '发布时间：',
          //   model: 'created_date',
          //   type: 'text',
          //   status: 0
          // },
          {
            label: '发布时间：',
            model: 'fb_time',
            type: 'text',
            status: 0
          },
          {
            label: '来源: ',
            model: 'fb_organization',
            type: 'text',
            status: 0
          }
          // {
          //     label: "点赞人数：",
          //     model: "like_num",
          //     type: "text",
          //     status: 0,
          // },
          // {
          //     label: "查阅人数：",
          //     model: "look_num",
          //     type: "text",
          //     status: 0,
          // },
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      types: () => {
        return new Promise((resolve) => {
          api.notes.retrieve.informationTypes().then((res) => {
            resolve(res.data.data)
          })
        })
      },
      data1: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.information(obj).then((res) => {
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.informationDto(obj).then((res) => {
            res.data[0].show3 = res.data[0].look_num
            resolve(res.data[0])
          })
        })
      }
    }
  },
  standard: {
    viewInfo: {
      obj: {
        basics1: [
          {
            label: '中国标准分类号（CCS）：',
            model: 'number_ics'
          },
          {
            label: '国际标准分类号（ICS）：',
            model: 'number'
          },
          {
            label: '发布日期：',
            model: 'fabu_time'
          },
          {
            label: '实施日期：',
            model: 'ss_time'
          },
          {
            label: '主管部门：',
            model: 'competent'
          },
          {
            label: '发布单位：',
            model: 'publish_org'
          }
        ],
        basics2: [
          // {
          //     label: "点赞",
          //     model: "like_num",
          //     type: "text",
          //     status: 0,
          // },
          // {
          //     label: "|",
          //     model: "",
          //     type: "text",
          //     status: 0,
          // },
          {
            label: '阅读',
            model: 'look_num',
            type: 'text',
            status: 0
          },
          {
            label: '|',
            model: '',
            type: 'text',
            status: 0
          },
          {
            label: '下载',
            model: 'download',
            type: 'text',
            status: 0
          },
          {
            label: '|',
            model: '',
            type: 'text',
            status: 0
          },
          {
            label: '上传',
            model: 'created_data',
            type: 'text',
            status: 0
          },
          {
            label: '|',
            model: '',
            type: 'text',
            status: 0
          },
          {
            label: '页数：',
            model: 'pdfPage',
            type: 'text',
            status: 0
          }
        ],
        btns1: [
          {
            label: '收藏',
            model: 'evaluate',
            type: 'card',
            status: 0
          }
          // {
          //     label: "分享",
          //     model: "share",
          //     type: "card",
          //     status: 0,
          // },
          // {
          //     label: "转存",
          //     model: "unload",
          //     type: "card",
          //     status: 0,
          // },
          // {
          //     label: "举报",
          //     model: "inform",
          //     type: "card",
          //     status: 0,
          // },
        ],
        btns2: [
          {
            label: '',
            model: 'comment',
            type: 'img',
            status: 0
          },
          {
            label: '|',
            model: '',
            type: 'text',
            status: 0
          },
          {
            label: '收藏',
            model: 'evaluate',
            type: 'img',
            status: 0
          },
          {
            label: '分享',
            model: 'share',
            type: 'img',
            status: 0
          },
          {
            label: '转存',
            model: 'unload',
            type: 'img',
            status: 0
          },
          {
            label: '举报',
            model: 'inform',
            type: 'img',
            status: 0
          }
        ],
        leftList: [
          {
            type: 'text',
            label: '相关学校推荐',
            model: ''
          }
        ],
        rightObj: {
          text: '',
          icon: 'right',
          type: 'button',
          path: '/school'
        },
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' }
          ],
          info: [
            { required: true, message: '请输入内容', trigger: 'blur' }
          ]
        },
        table: [
          {
            type: 'text',
            model: 'serialNum',
            label: '序号',
            width: '75',
            align: 'center'
          },
          {
            type: 'text',
            model: 'number',
            label: '标准编号',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'article_name',
            label: '标准名称',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'status_str',
            label: '状态',
            width: '100',
            align: 'center'
          },
          {
            type: 'text',
            model: 'type_str',
            label: '应用场景',
            width: '150',
            align: 'center'
          },
          {
            type: 'text',
            model: 'fabu_time',
            label: '发布时间',
            width: '125',
            align: 'center'
          },
          {
            type: 'text',
            model: 'ss_time',
            label: '实施日期',
            width: '125',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      types: () => {
        return new Promise((resolve) => {
          api.notes.retrieve.standardTypes().then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item, index) => {
                item.key = index
                item.type = 'text'
              })
            }
            resolve(res.data.data)
          })
        })
      },
      data: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.standard(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item, index) => {
                item.serialNum = res.data.from + index
              })
            }
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.standardDto(obj).then((res) => {
            if (res.data[0].img_url) {
              res.data[0].pdfPage = res.data[0].img_url.length
            }
            resolve(res.data[0])
          })
        })
      },
      about1: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.standardAbout1(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item) => {
                item.img = ''
              })
            }
            resolve(res.data)
          })
        })
      },
      about2: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.standardAbout2(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item) => {
                item.name = item.article_name
                item.num = item.look_num
                item.img = item.cover_img
              })
            }
            resolve(res.data)
          })
        })
      }
    }
  },
  help: {
    viewInfo: {
      obj: {
        basics: [
          // {
          //     label: "类型：",
          //     model: "type_name",
          //     type: "text",
          //     status: 0,
          // },
          // {
          //   label: '发布时间：',
          //   model: 'created_date',
          //   type: 'text',
          //   status: 0
          // }
          {
            label: '发布时间：',
            model: 'fb_time',
            type: 'text',
            status: 0
          },
          {
            label: '来源: ',
            model: 'fb_organization',
            type: 'text',
            status: 0
          }
          // {
          //     label: "点赞人数：",
          //     model: "like_num",
          //     type: "text",
          //     status: 0,
          // },
          // {
          //     label: "查阅人数：",
          //     model: "look_num",
          //     type: "img",
          //     status: 0,
          // },
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      types: () => {
        return new Promise((resolve) => {
          api.notes.retrieve.helpTypes().then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item, index) => {
                item.key = index
                item.type = 'text'
              })
            }
            resolve(res.data.data)
          })
        })
      },
      data1: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.help(obj).then((res) => {
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.helpDto(obj).then((res) => {
            res.data[0].endorse3 = res.data[0].like_num
            res.data[0].show3 = res.data[0].look_num
            resolve(res.data[0])
          })
        })
      }
    }
  },
  notice: {
    viewInfo: {
      obj: {
        basics: [
          // {
          //     label: "类型：",
          //     model: "type_name",
          //     type: "text",
          //     status: 0,
          // },

          {
            label: '发布时间：',
            model: 'fb_time',
            type: 'text',
            status: 0
          },
          {
            label: '来源: ',
            model: 'fb_organization',
            type: 'text',
            status: 0
          }
          // {
          //     label: "点赞：",
          //     model: "endorse3",
          //     type: "img",
          //     status: 0,
          // },
          // {
          //     label: "查阅：",
          //     model: "show3",
          //     type: "img",
          //     status: 0,
          // },
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      data1: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.notice(obj).then((res) => {
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.noticeDto(obj).then((res) => {
            // res.data.endorse3 = res.data.like_num;
            // res.data.show3 = res.data.look_num;
            if (res.data.file_url.length) {
              res.data.file_url.map(item => {
                item.src = `${process.env.VUE_APP_BASE_API
                }api/download_pdf?url=${decodeURIComponent(item.url)}`
              })
            }
            resolve(res.data)
          })
        })
      }
    }
  },
  message: {
    viewInfo: {
      obj: {
        basics: [
          // {
          //     label: "类型：",
          //     model: "type_name",
          //     type: "text",
          //     status: 0,
          // },
          // {
          //   label: '发布时间：',
          //   model: 'created_at',
          //   type: 'text',
          //   status: 0
          // }
          {
            label: '发布时间：',
            model: 'fb_time',
            type: 'text',
            status: 0
          },
          {
            label: '来源: ',
            model: 'fb_organization',
            type: 'text',
            status: 0
          }
          // {
          //     label: "点赞：",
          //     model: "endorse3",
          //     type: "img",
          //     status: 0,
          // },
          // {
          //     label: "查阅：",
          //     model: "show3",
          //     type: "img",
          //     status: 0,
          // },
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      data1: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.message(obj).then((res) => {
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.notes.retrieve.messageDto(obj).then((res) => {
            // res.data[0].endorse3 = res.data[0].like_num;
            // res.data[0].show3 = res.data[0].look_num;
            resolve(res.data)
          })
        })
      }
    }
  }

}
export default notes
